import { Router, ActivatedRoute } from '@angular/router';
import { NotificationsService } from '../shared/notifications.service';
import { INotification } from '../shared/notifications.model';
import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';

import * as moment from 'moment';
import * as L from 'leaflet';

@Component({
  selector: 'app-notification-edit',
  templateUrl: './notification-edit.component.html',
  styleUrls: ['./notification-edit.component.scss']
})
export class NotificationEditComponent implements OnInit {
  isSubmitting = false;
  editMode = false;
  notification: INotification = {
    name: 'Tin push chưa đặt tên',
    ts: moment().format('YYYY-MM-DDTHH:mm'),
    scheduledAt: moment(this.ceilDateTime(new Date()))
      .add(30, 'minute')
      .format('YYYY-MM-DDTHH:mm'),
    subject: 'Sở GTVT TpHCM thông báo',
    content: 'Tổ chức phân luồng giao thông đường ...',
    status: 'draft',
    values: {},
    geo: {}
  };

  public types = [
    {
      id: 'announcement',
      name: 'Tin tức'
    },
    {
      id: 'others',
      name: 'Khác'
    }
  ];

  private map: L.Map;
  private marker: L.Marker;

  ceilDateTime(date: Date, minute: number = 10) {
    return Math.ceil(date.getTime() / (minute * 60 * 1000)) * (minute * 60 * 1000);
  }
  constructor(
    private service: NotificationsService,
    private router: Router,
    private route: ActivatedRoute,
    private location: Location
  ) {}

  prepDataForSummit(notification: INotification) {
    notification.ts = moment(<string>notification.ts, 'YYYY-MM-DDTHH:mm').format();
    notification.scheduledAt = moment(notification.scheduledAt, 'YYYY-MM-DDTHH:mm').format();

    return notification;
  }

  prepareDataMarker(marker: L.Marker) {
    let responseMarker = {};
    if (marker) {
      responseMarker = {
        type : 'Feature',
        geometry : {
            type : 'Point',
            coordinates : [ marker.getLatLng().lng , marker.getLatLng().lat ]
        }
      }
    }
    return responseMarker;
  }

  clearMarker() {
    if (this.marker) {
      this.map.removeLayer(this.marker);
      this.marker = null;
    }
  }

  create(notification: INotification) {
    this.isSubmitting = true;
    notification = this.prepDataForSummit(notification);
    notification.geo = this.prepareDataMarker(this.marker);

    this.service.create(notification).subscribe(result => {
      this.isSubmitting = false;
      this.router.navigate(['/notifications']);
    });
  }

  update(notification: INotification) {
    this.isSubmitting = true;
    notification = this.prepDataForSummit(notification);
    notification.geo = this.prepareDataMarker(this.marker);

    this.service.update(notification._id, notification).subscribe(result => {
      this.isSubmitting = false;
      this.router.navigate(['/notifications']);
    });
  }

  get(id: string) {
    this.service.get(id).subscribe(
      notification => {
        notification.ts = moment(notification.ts).format('YYYY-MM-DDTHH:mm');
        notification.scheduledAt = moment(notification.scheduledAt).format('YYYY-MM-DDTHH:mm');
        notification.values = notification.values || {};

        this.editMode = true;
        this.notification = notification;
        if (this.notification.geo) {
          this.initMap(this.notification.geo);
        } else {
          this.initMap(null);
        }
      },
      error => this.router.navigate(['/notifications'])
    );
  }

  back() {
    this.location.back();
  }

  initMap(geo: any) {
    let corLat = 10.777093006214637;
    let corLng = 106.69547438621521;
    let zoomLevel = 13;

    this.map = L.map('map', {
      center: L.latLng(corLat, corLng),
      zoom: zoomLevel,
      attributionControl: false,
      scrollWheelZoom: false
    });
    L.tileLayer('//map.thongtingiaothong.vn/transport-full/{z}/{x}/{y}.png', {}).addTo(this.map);

    if (geo) {
      corLat = geo.geometry.coordinates[1];
      corLng = geo.geometry.coordinates[0];
      zoomLevel = 16;

      this.map.setView([corLat, corLng], zoomLevel);

      this.marker = new L.Marker([corLat, corLng], {
        icon: new L.Icon({
          iconUrl: 'assets/images/marker-icon.png',
          iconSize: [25, 41],
          iconAnchor: [12.5, 41]
        }),
        draggable: false
      }).addTo(this.map);
    }

    this.map.on('click', (e: L.LeafletMouseEvent) => {
      if (this.marker) {
        this.map.removeLayer(this.marker);
      }

      this.marker = new L.Marker([e.latlng.lat, e.latlng.lng], {
        icon: new L.Icon({
          iconUrl: 'assets/images/marker-icon.png',
          iconSize: [25, 41],
          iconAnchor: [12.5, 41]
        }),
        draggable: false
      }).addTo(this.map);
    });
  }

  ngOnInit() {
    const id = this.route.snapshot.params.id;
    if (id) {
      this.get(id);
    } else {
      this.initMap(null);
    }
  }
}



// WEBPACK FOOTER //
// /ng-app/src/app/notifications/notification-edit/notification-edit.component.ts